<template>
  <div class="content blacklist">
    <div class="header">
      <el-button type="primary" size="small" @click="addSlice">添加等级</el-button>
    </div>
    <template>
      <el-table :data="tableData" border style="width: 100%" size="small">
        <el-table-column prop="level" label="等级" ></el-table-column>
        <el-table-column prop="level_name" label="等级名称"></el-table-column>
        <el-table-column prop="spread_num" label="下线人数"></el-table-column>
        <el-table-column prop="custom_amount" label="分销消费金额"></el-table-column>
        <el-table-column prop="recharge_amount" label="分销充值金额"></el-table-column>
        <el-table-column prop="spread_amount" label="分销总金额"></el-table-column>
        <el-table-column prop="total_num" label="分销加油升数"></el-table-column>
        <el-table-column prop="gas_num" label="分销汽油升数"></el-table-column>
        <el-table-column prop="diesel_num" label="分销柴油升数"></el-table-column>
        <el-table-column prop="create_time" label="创建时间"></el-table-column>
  
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-link class="el-text" type="primary" @click="edit_con(scope.row.id)">编辑</el-link>
            <el-link class="el-text" type="success" @click="deleteRow(scope.$index, scope)">删除</el-link>
            <el-link class="el-text" 
              :type="scope.row.status == 0 ? 'warning':'danger'"  
              @click="change_status(scope.row.id, scope.row.status == 1 ? 0:1)"
            >
              {{scope.row.status == 0 ? '禁用':'启动'}}
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </template>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getlevel, dellevel, change_spread } from "@/api/user";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      page_id: "",
      tableData: [],
      dialogFormVisible: false,
      form: {
        name: '',
        region: '',
      },
      formLabelWidth: '120px'

    };
  },
  mounted() {
    this.page_id = this.$route.params.id;
    this.get_list();
  },
  methods: {
    edit_con(id) {
      this.$router.push('edit_grade?id=' + id)
    },
    deleteRow(val, item) {
      console.log(val, item)
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var data = { token: this.token, app_id: this.app_id, id: item.row.id };
        dellevel(data).then(result => {
          if (result.code == 200) {
            this.$message.success('删除成功');
            this.get_list();
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    // 修改分销状态
    async change_status(id, status) {
      try {
        var data = { app_id: this.app_id, id, status };
        const res = await change_spread(data);
        if (res.code == 200) {
          this.$message.success(res.msg); 
          this.get_list();
        } else {
          this.$message.error(res.msg); 
        }
      } catch (error) {
        console.log(error);
      }
    },
    async get_list() {
      try {
        var data = { token: this.token, app_id: this.app_id, page: 1 };
        const res = await getlevel(data);
        if (res.code == 200) {
          this.tableData = res.data
        }
      } catch (error) {
        console.log(error)
      }
    },
    addSlice() {
      this.$router.push({
        path: `adgrade`
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
  .el-text {
    margin-left: 10px;
  }
}
.blacklist {
  padding: 10px 25px;
  .header {
    border-bottom: 0;
    background-color: #f8f8f8;
    position: relative;
    padding-left: 24px;
    margin-bottom: 15px;
    padding: 10px 15px;
  }
  .img {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    img {
      width: 80%;
    }
  }
}
</style>

<style lang="scss">
.blacklist {
  .has-gutter > tr > th {
    color: #333;
    background-color: #f8f8f8;
  }
  .cell {
    text-align: center;
  }
}
</style>
